<script setup lang="ts">
import { PublicSellerFaqDoc } from '@gql/PublicSellerFaqDoc'

const props = defineProps<{
  item: gen.SellerFaqQaSmallFragment | None
}>()

const { ui: faqDoc, loading } = useApolloWrap2<gen.PublicSellerFaqDocQuery, gen.PublicSellerFaqDocQueryVariables>(PublicSellerFaqDoc)({
  vars() {
    const slug = props.item?.slug
    return slug ? { slug } : undefined
  },
  ui: (i) => i?.publicSellerFaqDoc,
})
const activeDoc = computed((): {
  documentId: string | None
  title: string | None
  body: string | None
  id: string | None
} | undefined => {
  const item = props.item
  const doc = faqDoc.value
  if (item?.slug && doc) {
    return { documentId: doc?.document?._id, title: item?.title?.value, body: item.text?.value, id: doc._id }
  }
  return undefined
})
</script>

<template>
  <div v-if="activeDoc">
    <div v-if="activeDoc.body" class="_txt">{{ activeDoc.body }}</div>
    <DocumentUi :document-id="activeDoc.documentId" />
  </div>
  <LazyUiLoadingBox v-else-if="loading" :repeat="3" height="_h20" width="_w70ch" mb="_mb04" />
</template>
